import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseDTO } from '../../dtos/response-dto';
import { AuthenticationService } from '../../login/authentication/authentication.service';

@Component({
  selector: 'custom-nav-bar',
  templateUrl: './custom-nav-bar.component.html',
  styleUrls: ['./custom-nav-bar.component.css']
})
export class CustomNavBarComponent implements OnInit {

  isAdminOuRoot: boolean = false;

  isAdminAtdOuAdminOuRoot: boolean = false;

  isUsuarioLogado: boolean = false;

  perfil: string | null = null;

  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    let usuarioLogado = JSON.parse(localStorage.getItem('currentUser') || '{}');

    if (!usuarioLogado.username) {
      usuarioLogado = new ResponseDTO(null, null, null);
    }

    this.perfil = usuarioLogado.perfil;

    this.isAdminOuRoot = (this.perfil != null && (this.perfil === 'ROLE_ADMIN' || this.perfil === 'ROLE_ROOT'));

    this.isAdminAtdOuAdminOuRoot = (this.perfil != null && this.perfil === 'ROLE_ADMIN_ATENDIMENTO') || this.isAdminOuRoot;

    this.isUsuarioLogado = this.isAdminAtdOuAdminOuRoot || (this.perfil !== null);
  }

  manutencaoPlanoSaude(): void {
    this.router.navigate(['planoSaude']);
  }

  manutencaoMedico(): void {
    this.router.navigate(['medicos']);
  }

  manutencaoUsuario(): void {
    this.router.navigate(['usuarios']);
  }

  manutencaoEspecialidade(): void {
    this.router.navigate(['especialidades']);
  }

  manutencaoSubEspecialidade(): void {
    this.router.navigate(['procedimentoConsulta']);
  }

  manutencaoFaltaMedica(): void {
    this.router.navigate(['faltaMedica']);
  }

  manutencaoAgendaMedica(): void {
    this.router.navigate(['agendaMedica']);
  }

  manutencaoFilial(): void {
    this.router.navigate(['filiais']);
  }

  manutencaoAssociacaoFilialMedico(): void {
    this.router.navigate(['associacaoFilialMedico']);
  }

  manutencaoAssociacaoFilialEspecialidade(): void {
    this.router.navigate(['associacaoFilialEspecialidade']);
  }

  manutencaoAssociacaoMedicoPlanoSaude(): void {
    this.router.navigate(['associacaoMedicoPlanoSaude']);
  }

  manutencaoAssociacaoPlanoSaudeProcedimento(): void {
    this.router.navigate(['associacaoPlanoSaudeProcedimento']);
  }

  manutencaoFeriados(): void {
    this.router.navigate(['feriados']);
  }

  manutencaoMotivoCancelamento(): void {
    this.router.navigate(['motivoCancelamento']);
  }

  manutencaoPaciente(): void {
    this.router.navigate(['pacientes']);
  }

  manutencaoDependente(): void {
    this.router.navigate(['dependentes']);
  }

  redefinirSenha(): void {
    this.router.navigate(['redefinicaoSenha']);
  }

  historicoEventosSistema(): void {
    this.router.navigate(['historicoEventosSistema']);
  }

  relDisponibilidadeDeVagasParaConsulta(): void {
    this.router.navigate(['relDisponibilidadeDeVagasParaConsulta']);
  }

  relMarcacoesInternasParaConsulta(): void {
    this.router.navigate(['relMarcacoesInternasParaConsulta']);
  }

  relMarcacoesConsultas(): void {
    this.router.navigate(['relMarcacoesConsultas']);
  }

  relDisponibilidadeDeVagasParaExame(): void {
    this.router.navigate(['relDisponibilidadeDeVagasParaExame']);
  }

  relMarcacoesInternasParaExame(): void {
    this.router.navigate(['relMarcacoesInternasParaExame']);
  }

  relMarcacoesInternasGlobal(): void {
    this.router.navigate(['relMarcacoesInternasGlobal']);
  }

  relMarcacoesExames(): void {
    this.router.navigate(['relMarcacoesExames']);
  }

  notificacoesCancelamento(): void {
    this.router.navigate(['notificacoesCancelamento']);
  }

  envioComprovante(): void {
    this.router.navigate(['envioComprovante']);
  }

  reenvioComprovanteExame(): void {
    this.router.navigate(['reenvioComprovanteProcedimentoProcurarPaciente'], {
      state: {
        tipoMarcacao: 'TIPO_MARCACAO_EXAME'
      }
    });  
  }

  reenvioComprovanteConsulta(): void {
    this.router.navigate(['reenvioComprovanteConsultaProcurarPaciente'], {
      state: {
        tipoMarcacao: 'TIPO_MARCACAO_CONSULTA'
      }
    });  
  }

  manutencaoAtendimentoConsulta(): void {
    this.router.navigate(['atendimentoConsulta']);
  }

  localizarAtendimentoConsulta(): void {
    this.router.navigate(['localizaAtendimentoConsulta']);
  }

  manutencaoAtendimentoProcedimento(): void {
    this.router.navigate(['atendimentoProcedimento']);
  }

  localizarAtendimentoProcedimento(): void {
    this.router.navigate(['localizaAtendimentoProcedimento']);
  }

  manutencaoProcedimento(): void {
    this.router.navigate(['procedimentos']);
  }

  manutencaoProcedimentoAgenda(): void {
    this.router.navigate(['procedimentoAgenda']);
  }

  sair(): void {
    this.authenticationService.logout();
  }
}
